import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useHistory} from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import {
  Row,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  CardFooter,
  Col,
} from "reactstrap";
import { Colxx } from "../../../components/common/CustomBootstrap";
import { isNullOrEmpty } from "../../../config/ENV";
import { SearchCandidateService } from "../../../services/SearchCandidateService";
import { formattedMobileNumber } from "../../../utilities/phonenumberutility";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { dayDifference } from "../../../utilities/daysutility";
import { dateDifference } from "../../../utilities/dateutility";
const InviteViaText = (props) => {
  const history = useHistory();
  const location = useLocation();
  const idsList = location.state?.idsList;
  const [selectedSize, setSelectedSize] = useState();
  const [selectedCandidateList, setSelectedCandidateList] = useState([]);
  const [showTempContent, setShowTempContent] = useState(false);
  const [templates, setTemplates] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [message, setMessage] = useState("");
  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");
  const [candidateId, setCandidateId] = useState([]);
  const [idsBackList, setIdsBackList] = useState({ idsList });

  const handleMouseEnter = (id) => {
    setCandidateId(id);
    setShowTooltip(true);
  };
  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const [showTooltip, setShowTooltip] = useState(false);
  useEffect(() => {
    inviteSms();
  }, []);
  const quillModules = {
    toolbar: [
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };
  
  const quillFormats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];
  const inviteSms = () => {
    if (idsList.length > 0) {
      setContent("");
      setSubject("");
      setSelectedTemplate([]);

      SearchCandidateService.inviteSelectedCandidates(idsList).then(
        (response) => {
          try {
            let selectedsize = response.data.size;
            setSelectedSize(selectedsize);
            var candidateList = response.data.candidates;

            if (!isNullOrEmpty(candidateList)) {
              setSelectedCandidateList(candidateList);
              setCandidateId(candidateList);
            }
          } catch (error) {
            console.log("errorText===" + JSON.stringify(error));
          }
        }
      );
    } else {
      toast.error("Please select at least one candidate");
      return;
    }
  };
  useEffect(() => {
    getSmsTemplates();
  }, []);
  const getSmsTemplates = () => {
    SearchCandidateService.getSmsTemplate().then((response) => {
      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
            console.log("error" + JSON.stringify(response.data.error_message));
          }
        } else {
          if (response.data !== null) {
            let templates = response.data.templates;
            if (templates !== null) {
              setTemplates(templates);
            }
          }
        }
      } catch (err) {
        console.log("error" + JSON.stringify(err.message));
      }
    });
  };
  const sentSms = () => {
    if (isNullOrEmpty(selectedTemplate)) {
      toast.error("Please select sms template");
      return;
    }
    let y = [];
    const someList=candidateId.map((item)=>y.push(item.candidateId))
    SearchCandidateService.sendSms({
      subject: subject,
      message: content,
      // candidates: selectedCandidateList,
      candidateIds:y,
    }).then((response) => {
      try {
        if (response.data.success) {
          setSelectedCandidateList([]);
          setContent("");
          setSubject("");
        }
        history.push("/searchthankyou");
      } catch (error) {
        console.log("errorinemail+++" + JSON.stringify(error));
      }
    });
  };

  const showTemplateName = () => {
    if (
      selectedTemplate == null ||
      selectedTemplate == "" ||
      selectedTemplate == undefined
    ) {
      return "";
    } else {
      return selectedTemplate.name;
    }
  };
  const handleTemplateChange = (e) => {
    if (isNullOrEmpty(e.target.value)) {
      setSelectedTemplate("");
    } else {
      for (var i = 0; i < templates.length; i++) {
        if (templates[i].id === e.target.value) {
          setSelectedTemplate(templates[i].name);
          setContent(templates[i].content);
          setSubject(templates[i].subject);
        }
      }
    }
  };
  const handleMessage = (value) => {
    setMessage(value);
    setContent(value);
  };
  const goToBack = () => {
    history.push("/searchcandidates", { idsBackList });
  };

  return (
    <>
      <Card className="w-100 mb-3 t-rounded-card">
        <strong>
          <h1 className="mt-4 ml-4">
            Invite{" "}
            {selectedSize == 1 ? (
              <>{selectedSize} candidate</>
            ) : (
              <>{selectedSize} candidates</>
            )}{" "}
            to job
          </h1>
        </strong>
        <CardBody className="t-invitecandidate-card pl-3 pr-3">
          <div>
            <div className="tableContainer ">
              <div className="tablewrapper">
                <Table className="hms_table jobRequisition_table table-responsive">
                  <thead className="t-searchtable-boredertop">
                    <tr>
                      <th className="w-15 ">Name</th>
                      <th className="w-15">Email</th>
                      <th className="w-10">Phone</th>

                      <th className="w-20">Location</th>

                      <th className="w-10">Registered</th>

                      <th className="w-10">Ratings</th>

                      <th className="w-20">Reqs</th>
                      <th className="w-15"></th>
                    </tr>
                  </thead>
                  {selectedCandidateList.length > 0 &&
                    selectedCandidateList.map((item, index) => (
                      <tbody key={index}>
                        <tr>
                        <td className="w-[120] t-search-primarycolor">
                          {item.firstName} {item.lastName}{" "}
                        </td>
                        <td className="w-[120] t-search-email-font">{item.email}</td>
                        <td className="w-[120]">
                          {formattedMobileNumber(item.contactNumber)}{" "}
                        </td>
                        <td className="w-[120]">
                          {!isNullOrEmpty(item.workLocation) ? (
                            <>{item.workLocation.city}</>
                          ) : (
                            <></>
                          )}{" "}
                        </td>
                        <td className="w-180">
                          {dayDifference(item.createdOn)}
                        </td>
                        <td className="w-[120]">{item.peerRaters}</td>
                        <td className="w-180">
                          <div>
                            {item.jobApplications.length > 0 &&
                              item.jobApplications
                                .slice(0, 3)
                                .map((employer, index) => (
                                    <ul className="mb-0" key={index}>
                                      {" "}
                                      {employer.employerJobId} -{" "}
                                      {employer.applicantStatus.value}{" "}
                                    </ul>
                                ))}
                          </div>
                          {item.jobApplications.length > 3 ? (
                            <>
                              <span
                                className="t-read-more-color t-cursor-pointer"
                                onMouseEnter={() => handleMouseEnter(item.id)}
                                onMouseLeave={handleMouseLeave}
                              >
                                Read More
                              </span>
                            </>
                          ) : (
                            <></>
                          )}

                          {showTooltip && candidateId === item.id && (
                            <>
                              {item.jobApplications.length > 3 ? (
                                <>
                                  <div className="t-tooltip-searchcand">
                                    <Row>
                                      <Col sm={8} className="t-padding-right-tooltip">
                                        <div>
                                          {item.jobApplications.length > 3 &&
                                            item.jobApplications
                                              .slice(
                                                3,
                                                item.jobApplications.length
                                              )
                                              .map((employer, index) => (
                                                <>
                                                  <ul className="mb-0">
                                                    {" "}
                                                    {
                                                      employer.employerJobId
                                                    } -{" "}
                                                    {
                                                      employer.applicantStatus
                                                        .value
                                                    }{" "}
                                                  </ul>
                                                </>
                                              ))}
                                        </div>
                                      </Col>
                                      <Col sm={4}>
                                        {item.jobApplications.length > 3 &&
                                          item.jobApplications
                                            .slice(
                                              3,
                                              item.jobApplications.length
                                            )
                                            .map((employer, index) => (
                                                <ul className="mb-0">
                                                  <span>
                                                    {" "}
                                                    {dateDifference(
                                                      employer.modifiedOn
                                                    )}
                                                  </span>
                                                </ul>
                                            ))}
                                      </Col>
                                    </Row>
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </>
                          )}
                        </td>
                        <td className="w-180">
                          <div>
                            {item.jobApplications.length > 0 &&
                              item.jobApplications
                                .slice(0, 3)
                                .map((employer, index) => (
                                
                                    <ul className="mb-0" key={index}>
                                      {" "}
                                      {dateDifference(employer.modifiedOn)}
                                    </ul>
                                
                                ))}
                          </div>
                        </td>
                        </tr>
                      </tbody>
                    ))}
                </Table>
              </div>
            </div>
          </div>
        </CardBody>

        <CardFooter className="t-invitecard-footer mt-3 t-rounded-card">
          <Row>
            <Colxx sm={1} className="t-text-align">
              <label className="lable-text">Templates*</label>
            </Colxx>
            <Colxx sm={8}>
              <Input
                className="t-rounded-lg t-email-input-width"
                type="select"
                data-testid="templateId"
                value={showTemplateName()}
                onChange={(e) => handleTemplateChange(e)}
              >
                <option value="">Select sms template</option>

                {templates.length > 0 &&
                  templates.map((template) => {
                    return (
                      <option key={template.id} value={template.id}>
                        {template.name}
                      </option>
                    );
                  })}
              </Input>
            </Colxx>
          </Row>
          {setShowTempContent && (
            <>
              {!isNullOrEmpty(selectedTemplate) ? (
                <>
                  <Row>
                    <Colxx sm={1} className="t-text-align">
                      <label className="lable-text ">Message</label>
                    </Colxx>
                    <Colxx sm={8}>
                    <Input
                        className="req_dropdown t-rounded-lg t-textarea-width "
                        type="textarea"
                        placeholder="Invite candidate to Req ID(Separate multiple IDs with commas)"
                        onChange={(e) => handleMessage(e.target.value)}
                        value={content}
                      ></Input>
                    </Colxx>
                  </Row>
                </>
              ) : (
                <></>
              )}
            </>
          )}
         
         <Button
            className="btn-sm mt-3 t-button-search-col "
            outline
                          color="primary mr-2"
            onClick={() => goToBack()}
          >
            Back
          </Button>
          <Button
            className="btn-sm mt-3 t-button-search-col "
            outline
                          color="primary mr-2"
            onClick={() => sentSms()}
          >
            Send Sms
          </Button>
        </CardFooter>
      </Card>
    </>
  );
};
export default InviteViaText;
